import React from 'react';
import { motion } from 'framer-motion';
import './RACLeaseRent.css';

const RACLeaseRent = () => {
  console.log('[RACLeaseRent] Component rendered');
  
  return (
    <section className="rac-lease-rent">
      <div className="rac-lease-rent-container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="rac-lease-rent-content"
        >
          <h2 className="rac-section-title">Lease Rent</h2>
          <div className="rac-gold-line"></div>
          <div className="rac-lease-rent-text">
            <p>
              Under the lease agreement, you receive contractual monthly lease rent equivalent to approximately 18% annualized rent on the contract value.
            </p>
            <div className="rac-lease-examples">
              <p>Examples:</p>
              <ul>
                <li>₹2,50,000 → approx. ₹3,750 per month</li>
                <li>₹5,00,000 → approx. ₹7,500 per month</li>
                <li>₹10,00,000 → approx. ₹15,000 per month</li>
              </ul>
            </div>
            <div className="rac-lease-details">
              <p><strong>Lease tenure:</strong> 5 years</p>
              <p><strong>Minimum asset purchase:</strong> ₹2,50,000</p>
              <p><strong>Lease payments begin:</strong> the month following lease activation.</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default RACLeaseRent;


